import { IBaseEntity } from './common.type';
import { IPlaylist } from './playlist.type';

export interface IPlaylistSource extends IBaseEntity {
  name: string;
  time?: number;
  url?: string;
  play_url?: string;
  text_to_speech?: string;
  no: number;
  type: EPlaylistSourceType;
  volume?: number;
  url_store?: string;
  expired?: number;
  url_temp?: string;
  playlist_id: string;
  playlist: IPlaylist;
}

export enum EPlaylistSourceType {
  LIST = 'LIST',
  FILE = 'FILE',
  URL = 'URL',
  TEXT_TO_SPEECH = 'TEXT_TO_SPEECH',
  MICRO = 'MICRO',
}
